import React from 'react';
import { CSVReader } from 'react-papaparse'
import { PrimaryButton, Modal, Pulse } from 'wf-react-component-library';
import ItemApi from '../api/virs/ItemApi';
import { validateVirmItemWithConstraints } from '../services/validation/VirmItem';
import { fromCSVItem } from '../services/data-transform/VirmItem';
import { getCoolersByVendor } from '../api/p3/VendorCoolerApi';


import './UploadCSVModal.scss';

class UploadCSVModal extends React.Component  {
  constructor(props) {
    super(props);
    this.state = {
      errorMessages: [],
      locationKeys: [],
      countryOfOriginKeys: [],
      isSuccess: false,
      isLoadingData: false
    };

    this.handleOnDrop = this.handleOnDrop.bind(this);
    this.handleOnError = this.handleOnError.bind(this);
    this.handleOnRemoveFile = this.handleOnRemoveFile.bind(this);
  }

  componentDidMount = () => {
    const locationKeys = [];
    Object.keys(this.props.locations).forEach(key => locationKeys.push(key));
    
    const countryOfOriginKeys = [];
    Object.keys(this.props.countryOfOrigins).forEach(key => countryOfOriginKeys.push(key));

    this.setState({
      locationKeys,
      countryOfOriginKeys
    })
  }

  handleOnDrop = async (data) => {
    this.setState({
      isLoadingData: true
    })
    var cnt = 0;

    // GET cooler codes by Vendor Code
    const vendorCode = (data[1]).data[1];

    const { locationKeys, countryOfOriginKeys } = this.state;
    const { currentUser } = this.props;

    const coolerDetails = await getCoolersByVendor(vendorCode);
    const coolerKeys = [];
    coolerDetails.forEach(coolerItem => coolerKeys.push(coolerItem.code));

    for (const vendorItem of data) {
      if (vendorItem.data.length > 1) {
        const csvItem = vendorItem.data;
        var virmItem;
        
        if (cnt > 0) {

          virmItem = fromCSVItem(csvItem);
          virmItem.modifiedBy = currentUser;

          // Check if Virm Item exists (in case they change the Vendor Item Id accidentally)
          const errorsForNonEditableFields = [];
          
          try {
            const vendorItemDetails = await ItemApi.getItemByVendorItemId(virmItem.vendorId, virmItem.vendorItemId);

            if (vendorItemDetails.itemId !== virmItem.itemId) {
              errorsForNonEditableFields.push(`You cannot change the Item_Number for ${virmItem.vendorItemId} from ${vendorItemDetails.itemId} to ${virmItem.itemId}. Item_Number is a non-editable field.`)
            }

            if (vendorItemDetails.vendorId !== virmItem.vendorId) {
              errorsForNonEditableFields.push(`You cannot change the Vendor_Code for ${virmItem.vendorItemId} from ${vendorItemDetails.vendorId} to ${virmItem.vendorId}. Vendor_Code is a non-editable field.`)
            }
          } catch {
            errorsForNonEditableFields.push(`This Virm Item, ${virmItem.vendorItemId}, does not exist. Vendor_Item_Id is non-editable field.`);
          }

          if (errorsForNonEditableFields.length > 0 ) {

            //set state and get next records, no need to validate the data
            const { errorMessages } = this.state;
            errorMessages.push({
              record: cnt+1,
              data: virmItem,
              errors: errorsForNonEditableFields
            });
            this.setState({ errorMessages, isSuccess: false, isLoadingData: false });

          } else {
            const { errors } = validateVirmItemWithConstraints(virmItem, locationKeys, countryOfOriginKeys, coolerKeys);

            if (errors === null) {
              await ItemApi.patch(virmItem.vendorId, virmItem, virmItem.vendorItemId, 'someApiToken');
            } else {
              var errorDetails = [];

              for (const [key, details] of Object.entries(errors)) {
                errorDetails.push(`${details} - current value is ${virmItem[key]}`);
              }

              const errorsForRecord = {
                record: cnt+1,
                data: virmItem,
                errors: errorDetails
              }

              const { errorMessages } = this.state;
              errorMessages.push(errorsForRecord);
              this.setState({ errorMessages, isSuccess: false, isLoadingData: false });
            }
          }
        }

        cnt++;
      }
    }

    if (this.state.errorMessages.length === 0) {
      this.setState({ isSuccess: true, isLoadingData: false });
    }
  }

  handleOnError = (err, file, inputElem, reason) => {
    console.log('Error on File Upload');
    console.log('---------------------------')
    console.log(err);
    console.log(file);
    console.log(inputElem);
    console.log(reason);
    console.log('---------------------------')
  }

  handleOnRemoveFile = (data) => {
    this.setState({errorMessages: [], isSuccess: false});
  }

  render () {    
    var errors = null;
    if (this.state.errorMessages.length > 0) {
      errors = this.state.errorMessages.map((error) => {
        var errorMessages = error.errors.join(', ');

        return (
          <tr key={error.record} className="item-row">
            <td>
              <span className="body-short-form">{error.record}</span>
            </td>
            <td>
              <span className="body-short-form">{error.data.vendorItemId}</span>
            </td>
            <td>
              <span className="body-short-form">{errorMessages}</span>
            </td>
          </tr>
        );
      });
    }

    return (
      <Modal show={true} width={"75%"}>
          <div className="flex-container-row item-details-container show">
              <div className="flex-container-row upload-csv">
                  <CSVReader
                      onDrop={this.handleOnDrop}
                      onError={this.handleOnError}
                      addRemoveButton
                      removeButtonColor='#004E36'
                      onRemoveFile={this.handleOnRemoveFile}
                  >
                      <span>Drop CSV file here or click to upload.</span>
                  </CSVReader>
              </div>

              <div className="flex-container-row buttons">
                  <PrimaryButton onClick={this.props.closeModal} name={"Close"} />
              </div>

              { this.state.isSuccess
                ? (<div className="flex-container-row success">
                    <div className="body-short-form success">Your data has been uploaded successfully.</div>
                   </div>
                  )
                : null
              }

              { this.state.isLoadingData
                  ? <Pulse text="Loading Data..." />
                  : null
              }

              { this.state.errorMessages.length > 0
                ? (<div className="flex-container-row errors">
                  <table className="errors-table" cellPadding="0" cellSpacing="0" width="100%">
                    <colgroup>
                      <col span="1" style={{ width: '8%' }} />
                      <col span="1" style={{ width: '30%' }} />
                    </colgroup>

                    <tbody>
                      <tr className="errors-table-header">
                        <td>Row</td>
                        <td>Vendor Item Id</td>
                        <td>Error(s)</td>
                      </tr>
                      { errors }
                    </tbody>
                  </table>
                </div>)
                : null
              }
          </div>
      </Modal>
    )
  }
}

export default UploadCSVModal;